import FormPIN from "@components/inputs/FormPIN";
import { usePostLoginCheck } from "@components/utils/Auth/hooks";
import { LoginCallbackProps } from "@components/utils/Auth/types";
import { SEON_FEATURE } from "@configs/seon";
import { useOnboardingPhone } from "@hooks/useOnboardingPhone";
import { useSeonSession } from "@hooks/useSeonSession";

interface LoginPPProps extends LoginCallbackProps {}

const LoginPP = ({ onForgotSecret, onLoginSuccess }: LoginPPProps) => {
  const { phone } = useOnboardingPhone();
  const postLoginCheck = usePostLoginCheck({
    onLoginSuccess,
  });
  useSeonSession(SEON_FEATURE.LOGIN, {
    autoInit: true,
  });

  return (
    <FormPIN
      phone={phone}
      onLoginSuccess={postLoginCheck}
      onForgotSecret={onForgotSecret}
      isInputNum={false}
    />
  );
};

export default LoginPP;
